import { Component, OnInit, Input } from '@angular/core';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { PortalState } from '@app/store/portal.state';
import { NavigateToUserProfile } from '@shared/store/shared.actions';

@Component({
  selector: 'prp-user-profile-editor',
  templateUrl: './user-profile-editor.component.html',
  styleUrls: ['./user-profile-editor.component.scss'],
})
export class UserProfileEditorComponent implements OnInit {
  @Select(PortalState.rtl2Employee)
  producer$: Observable<boolean>;

  @Input() profile: any;

  constructor(private store: Store) {}

  ngOnInit() {}
  redirectToSSoProfile() {
    this.store.dispatch(new NavigateToUserProfile());
  }
}
